import { getGlobalCssUrl, getComponentCssUrl } from '../../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavFooterLevel0LinksTemplate() {
    const t = document.createElement('template')
    t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavFooterLevel0Links--wc.css')}" rel="stylesheet" />
`
    return t;
}

const getTemplateNavFooterLevel0LinksStyles = () => createNavFooterLevel0LinksTemplate();
export { getTemplateNavFooterLevel0LinksStyles };
